import { Box, makeStyles, styled, Theme, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles((theme: Theme) => ({
  PlanSection: {
    background: '#344767',
    padding: 30,
    borderRadius: 8,
  },
  invisilbeWidth: {
    width: '5rem',
    [theme.breakpoints.up('md')]: {
      width: '20rem',
    },
  },
}));

export const PlanCard = styled(Box)({
  backgroundColor: 'white',
  border: '3px solid #fff',
  borderRadius: 8,
  height: '100%',
});

export const PlanCardHeader = styled(Box)({
  padding: '10px 30px',
  position: 'relative',
  backgroundColor: '#344767',
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
});

export const PriceContainer = styled(Box)(({ theme }) => ({
  color: '#fff',
  display: 'flex',
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    padding: '10px 0',
    alignItems: 'center',
  },
}));

export const PriceHeader = styled(Box)(({ hasFreeButton, theme }: any) => ({
  paddingTop: hasFreeButton ? '30px' : '',
  [theme.breakpoints.up('md')]: {
    paddingTop: hasFreeButton ? 'unset' : '',
  },
}));

export const PlanCardBody = styled(Box)({
  color: '#344767',
  padding: '20px 30px',
  backgroundColor: '#fff',
  display: 'grid',
  gap: 20,
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,
});

export const PlanListContainer = styled(Box)({
  display: 'grid',
  gap: 8,
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,
});

export const PlanListItem = styled(Typography)({
  position: 'relative',
  paddingLeft: 20,
  fontSize: '12px !important',
  color: '#344767',
  '&::before': {
    content: "'\\2713'",
    position: 'absolute',
    left: 0,
  },
});

export const PlanAdditional = styled(Box)({
  background: 'rgba(64, 89, 124, 0.08)',
  padding: '10px 20px',
  borderRadius: 8,
});

export const CardLabelContainer = styled(Box)(({ hasFreeButton, theme }: any) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  [theme.breakpoints.up('md')]: {
    position: 'static',
  },
}));

export const CardLabel = styled(Box)(({ theme }) => ({
  backgroundColor: '#A69332',
  borderTopRightRadius: 8,
  borderTopLeftRadius: 0,
  borderBottomRightRadius: 0,
  borderBottomLeftRadius: 8,
  padding: 5,
  display: 'flex',
  alignItems: 'center',

  [theme.breakpoints.up('md')]: {
    borderRadius: '8px !important',
    padding: '10px 20px',
    flexDirection: 'column',
    alignItems: 'unset',
  },
}));

export const CardMonthText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  [theme.breakpoints.up('md')]: {
    fontSize: 16,
  },
}));

export const CardFreetext = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  marginLeft: 5,
  fontWeight: 800,
  [theme.breakpoints.up('md')]: {
    marginLeft: 0,
    fontSize: 32,
  },
}));
